import CartSinglePage from './CartSinglePage'

export default CartSinglePage
// eslint-disable-next-line import/export
export * from './CartSinglePage'
